module.exports = __webpack_public_path__ + "img/222A1538.15b291ad.jpg";